import React from 'react'
import { useRouter } from 'next/router'
import { FormattedMessage } from 'react-intl'
import { Button } from '@material-ui/core'
import { ActiveLinkType, NextStepLink } from '../enum'
import { MilliplexFormValues } from '../Milliplex'
import { useFormikContext } from 'formik'
import messages from '../../../messages'
import windowScrollTo from '@utils/windowScrollTo'

interface NextStepButtonProps {
  setDisplayPageError: React.Dispatch<React.SetStateAction<boolean>>
}

const NextStepButtonComponent: React.FC<NextStepButtonProps> = ({
  setDisplayPageError,
}) => {
  const router = useRouter()
  const currentActiveLink = router.query.activeLink as string
  const formik = useFormikContext<MilliplexFormValues>()

  const handleNextStep = () => {
    router.push({
      pathname: router.pathname,
      query: {
        ...router.query,
        activeLink: NextStepLink[currentActiveLink],
        species: formik.values.species,
        researchAreas: formik.values.researchAreas,
        analytes: formik.values.analytes,
      },
    })
  }

  const nextAction = () => {
    if (!currentActiveLink) {
      // step 1
      formik.setTouched({ species: true, assay: true })
      setDisplayPageError(true) // for displaying the common error message
      if (formik.values.species !== '' && formik.values.assay !== '') {
        setDisplayPageError(false)
        handleNextStep()
      } else {
        windowScrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth',
        })
      }
    } else if (currentActiveLink === ActiveLinkType.SelectKits) {
      if (Object.keys(formik.values.selectedKits).length === 0) {
        formik.setTouched({
          analytes: true,
          plateType: true,
          instrumentType: true,
        })
        setDisplayPageError(true)
        windowScrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth',
        })
      } else {
        setDisplayPageError(false)
        handleNextStep()
      }
    }
  }

  return currentActiveLink !== ActiveLinkType.ReviewAndOrder ? (
    <Button
      id="milliplex-nextStep-button"
      variant="contained"
      size="medium"
      color="primary"
      onClick={nextAction}
    >
      <FormattedMessage {...messages.CONFIG_NEXT_STEP} />
    </Button>
  ) : (
    <></>
  )
}

export default NextStepButtonComponent
